module.exports = __webpack_public_path__ + "static/img/news_bg.2d79fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news_bg.png
// module id = k+VM
// module chunks = 0